import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

@Block() @Component
export class ApartmentAdditionalCostFeaturesBlock extends BaseBlock {
	expand: boolean = false;

	@Prop() apartment: ApartmentDTO;

	get additionalCostFeaturesList() {
		return (this.apartment.additionalCostFeaturesList || '').split('\n').filter(s => s.trim().length > 0);
	}
}

export default ApartmentAdditionalCostFeaturesBlock;
